import React from 'react'
import parse from 'html-react-parser';
import "./PillarVideosDetailsContent.css"
const PillarVideosDetailsContent = (pillarsVideoData) => {

    const url = pillarsVideoData?.pillarsVideoData?.link
    const videoId = url?.split('/')[3]?.split('?')[0];

    // Construct the embed URL format
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <>
            <section className='pillar-videos-details-con-page-content-section'>
                <div className="container">
                    <div className="blog-details-inner">
                        {pillarsVideoData?.pillarsVideoData?.summary ? <b> {parse(pillarsVideoData?.pillarsVideoData?.summary)}</b> :
                            <p> <b>In the ever-evolving landscape of power generation and distribution, technological advancements continue to shape the way we harness and utilize electricity. One such innovation that stands out for its precision and efficiency is Pure Sine Wave Technology. In this blog post, we'll delve into the intricacies of this technology, exploring its applications, benefits, and why it has become a cornerstone in various industries.</b></p>}
                    </div>
                    {pillarsVideoData?.pillarsVideoData?.link &&
                        <div className="blog-details-inner-video">
                            <iframe width="100%" height="391" src={pillarsVideoData?.pillarsVideoData?.link ? `${embedUrl}` : "https://www.youtube.com/embed/FFBnPT1Z5uA"} title={pillarsVideoData?.pillarsVideoData?.title ? pillarsVideoData?.pillarsVideoData?.title : "EAPRO Industrial Visit by Teerthanker Mahaveer University"} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                        </div>}
                    <div className="blog-details-inner">
                        {pillarsVideoData?.pillarsVideoData?.description ? parse(pillarsVideoData?.pillarsVideoData?.description) :
                            ""}
                    </div>
                </div>
            </section >
        </>
    )
}

export default PillarVideosDetailsContent